import { render, staticRenderFns } from "./choose-vcard-dialog.vue?vue&type=template&id=4787d45b&scoped=true&"
import script from "./choose-vcard-dialog.vue?vue&type=script&lang=js&"
export * from "./choose-vcard-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4787d45b",
  null
  
)

export default component.exports